import axios from "axios";
import { env } from "src/config/env";
import { StorageKeys } from "../enums/StorageKeys.enum";
import { globalError } from "./globalError";

const apiClient = axios.create({
	baseURL: env.API_BASE_URL,
	headers: {
		"Content-Type": "application/json",
	},
});
const token = localStorage.getItem(StorageKeys.token);
if (token) apiClient.defaults.headers.common["authorization"] = token;

apiClient.interceptors.response.use(
	(response) => response.data,
	async (error) => {
		console.log("API Error Details:", {
			url: error.config?.url,
			method: error.config?.method,
			status: error.response?.status,
			data: error.response?.data || {},
			message: error.message,
		});
		const status = error.response?.status;

		// if (error.response?.status !== 401) {
		//   alert(`Error: ${error.response?.data?.error || error.message}`);
		// }

		if (!error.response) {
			return Promise.reject({
				response: {
					data: {
						code: "NETWORK_ERROR",
						message: "Unable to connect to server. Please check your internet connection.",
					},
				},
			});
		}
		if (status !== 401) {
			const msg = error.response?.data?.error || error.response?.data?.message || error.message || "Unknown server error";
			globalError.show(`Error ${status ?? ""}`.trim(), msg);
		}

		if (status === 401) {
			console.log("Unauthorized Access - Attempting to refresh token...");
			try {
				localStorage.removeItem(StorageKeys.token);
				delete apiClient.defaults.headers.common["authorization"];
				const currentPath = window.location.pathname;
				const authPages = ["/login"];
				if (!authPages.some((page) => currentPath.startsWith(page))) {
					window.location.href = "/login";
				}
			} catch (refreshError) {
				console.error("Failed to refresh token:", refreshError);
			}
		}

		return Promise.reject(error);
	},
);

export const get = async (url: string, options = {}) => {
	console.log(`API Request [GET] ${url}`);
	const response = await apiClient.get(url, options);
	return response;
};

export const post = async (url: string, data: any, options = {}) => {
	console.log(`API Request [POST] ${url}:`, data);
	console.log("OPTIONS", options);
	const response = await apiClient.post(url, data, options);
	return response;
};

export const put = async (url: string, data: any, options = {}) => {
	console.log(`API Request [PUT] ${url}:`, data);
	const response = await apiClient.put(url, data, options);
	return response;
};

export const del = async (url: string, options = {}) => {
	console.log(`API Request [DELETE] ${url}`);
	const response = await apiClient.delete(url, options);
	return response;
};
